let initialized = false

const setup = ($dom) => {
  initialized = true

  $dom.on('click', "[data-behaviour='show-more']", (evt) => {
    const $showMoreLink = $(evt.target)
    const $messageElement = $showMoreLink.closest('.audit-message')

    const elements = [
      $messageElement.find('.full-audit-message'),
      $messageElement.find('.message'),
      $showMoreLink,
    ]

    for (const elem of elements) {
      elem.toggleClass('sf-hidden')
    }
  })
}

onDomLoad(($dom) => {
  if (initialized) {
    return
  }

  setup($dom)
})
